module.exports = __webpack_public_path__ + "assets/img/no_data.ecb27067.png";